<app-page-header [breadcrumbs]="[
    {label: 'Home',         url: '/'},
    {label: 'Shop', url: '/shop'},
    {label: product?.name,  url: ''}
]"></app-page-header>

<ng-container>
    <div class="block">
        <div class="container" *ngIf="product">
            <app-product [product]="product" [layout]="layout"></app-product>
            <app-block-products-carousel
    header="Best Selling Products"
    [products]="latestProducts"
></app-block-products-carousel>
            <!-- <app-product-tabs [product]="product"></app-product-tabs> -->
        </div>
    </div>
</ng-container>

